/**
 *
 * @param {Object} state
 * @param {String} interventProductID
 */
const SET_SELECTED_DELIVERY_INTERVENTION_PRODUCT_ID = (state, interventProductID) => {
  interventProductID ? (state.delivery.interventProductID = interventProductID) : false;
};

/**
 *
 * @param {Object} state
 * @param {String} id
 */
const SET_SELECTED_DELIVERY_ID = (state, id) => {
  id ? (state.delivery.id = id) : false;
};

/**
 *
 * @param {Object} state
 * @param {String} id
 */
const SET_CURRENT_DELIVERY_ID = (state, currentId) => {
  currentId ? (state.delivery.currentId = currentId) : false;
};
/**
 *
 * @param {Object} state
 * @param {String} agencyId
 */
const SET_SELECTED_DELIVERY_AGENCY_ID = (state, agencyId) => {
  agencyId ? (state.delivery.agencyId = agencyId) : false;
};

/**
 *
 * @param {Object} state
 * @param {String} deliveryDateStart
 */
const SET_SELECTED_DELIVERY_DATE_START = (state, deliveryDateStart) => {
  deliveryDateStart ? (state.delivery.deliveryDateStart = deliveryDateStart) : false;
};

/**
 *
 * @param {Object} state
 * @param {String} deliveryDateEnd
 */
const SET_SELECTED_DELIVERY_DATE_END = (state, deliveryDateEnd) => {
  deliveryDateEnd ? (state.delivery.deliveryDateEnd = deliveryDateEnd) : false;
};

/**
 *
 * @param {Object} state
 * @param {String} selectedHours
 */
const SET_SELECTED_DELIVERY_SELECTED_HOURS = (state, selectedHours) => {
  selectedHours ? (state.delivery.selectedHours = selectedHours) : false;
};
/**
 *
 * @param {Object} state
 * @param {String} selectedDate
 */
const SET_SELECTED_DELIVERY_SELECTED_DATE = (state, selectedDate) => {
  selectedDate ? (state.delivery.selectedDate = selectedDate) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} payload
 */
const SET_SELECTED_DELIVERY_AGENCIES_DATA = (state, payload) => {
  payload ? (state.delivery.responseData.agenciesData = payload) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} payload
 */
const SET_SELECTED_DELIVERY_CALENDAR_DATA = (state, payload) => {
  payload ? (state.delivery.responseData.calendarData = payload) : false;
};

/**
 *
 * @param {Object} state
 * @param {String} start
 */
const SET_SELECTED_DELIVERY_CALENDAR_DATE_START = (state, start) => {
  start ? (state.delivery.responseData.calendarData.firstDate = start) : false;
};

/**
 *
 * @param {Object} state
 * @param {String} end
 */
const SET_SELECTED_DELIVERY_CALENDAR_DATE_END = (state, end) => {
  end ? (state.delivery.responseData.calendarData.lastDate = end) : false;
};

/**
 *
 * @param {Object} state
 * @param {String} postalCode
 */
const SET_SELECTED_DELIVERY_POSTAL_CODE = (state, postalCode) => {
  postalCode ? (state.delivery.postalCode = postalCode) : false;
};

/**
 *
 * @param {Object} state
 * @param {Number} slotId
 */
const SET_SELECTED_DELIVERY_SLOT_ID = (state, slotId) => {
  slotId ? (state.delivery.slotId = slotId) : false;
};

/**
 *
 * @param {Object} state
 * @param {Boolean} fakeSlot
 */
const SET_SELECTED_DELIVERY_FAKE_SLOT = (state, fakeSlot) => {
  fakeSlot ? (state.delivery.fakeSlot = fakeSlot) : false;
};

/**
 * 
 * Date when user slected a slot
 * For Countdown start
 */
const SET_SELECT_SLOT_DATE = (state, date) => {
  state.delivery.slotAvailability.slotUpdatedAt = date;
}

const SET_SERVER_DATE_NOW = (state, date) => {
  state.delivery.slotAvailability.serverDate = date;
}

const SET_DELIVERY_DATE_AVAILABILITY = (state, availability) => {
  state.delivery.isDeliveryDateAvailable = availability;
}

export default {
  SET_SELECTED_DELIVERY_ID,
  SET_CURRENT_DELIVERY_ID,
  SET_SELECTED_DELIVERY_INTERVENTION_PRODUCT_ID,
  SET_SELECTED_DELIVERY_SELECTED_HOURS,
  SET_SELECTED_DELIVERY_SELECTED_DATE,
  SET_SELECTED_DELIVERY_AGENCY_ID,
  SET_SELECTED_DELIVERY_DATE_START,
  SET_SELECTED_DELIVERY_DATE_END,
  SET_SELECTED_DELIVERY_AGENCIES_DATA,
  SET_SELECTED_DELIVERY_CALENDAR_DATA,
  SET_SELECTED_DELIVERY_CALENDAR_DATE_START,
  SET_SELECTED_DELIVERY_CALENDAR_DATE_END,
  SET_SELECTED_DELIVERY_POSTAL_CODE,
  SET_SELECTED_DELIVERY_SLOT_ID,
  SET_SELECTED_DELIVERY_FAKE_SLOT,
  SET_SELECT_SLOT_DATE,
  SET_SERVER_DATE_NOW,
  SET_DELIVERY_DATE_AVAILABILITY
};
